import React, { useContext, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { Container, Row, Col } from 'react-bootstrap'
import GlobalContext from '../../Context/Context'
import { useLanguage } from '../../Context/LanguageContext'

import logoLight from '../../Assets/img/imigo-logo.png'

const FooterImigo = () => {
  const { setFooterHeight } = useContext(GlobalContext)
  const { getLocalizedPath, t } = useLanguage()
  const footerRef = useRef(null)

  useEffect(() => {
    setTimeout(() => {
      setFooterHeight(footerRef.current.offsetHeight)
    }, 1000)

    window.addEventListener('resize', () => {
      setTimeout(() => {
        setFooterHeight(footerRef.current.offsetHeight)
      }, 1000)
    })
  }, [setFooterHeight])

  const quickLinks = [
    { to: '/', label: t('menu.home') },
    { to: '/articles', label: t('menu.articles') },
    { to: '/businesses', label: t('menu.businesses') },
    { to: '/events', label: t('menu.events') },
    { to: '/marketplace', label: t('menu.marketplace') },
  ]

  const resourceLinks = [
    { to: '/about', label: t('menu.about') },
    { to: '/contact', label: t('menu.contact') },
    { to: '/privacy', label: t('footer.privacy') },
  ]

  return (
    <footer ref={footerRef} className="footer-imigo py-[60px] bg-darkgray text-white">
      <Container>
        <Row className="justify-content-between">
          <Col lg={4} md={6} className="mb-[30px]">
            <Link to={getLocalizedPath('/')} className="mb-[20px] inline-block">
              <img src={logoLight} alt="Imigo Logo" className="h-[60px] w-auto" />
            </Link>
            <p className="mb-[20px]">{t('footer.tagline')}</p>
            <div className="social-icons">
              <a href="https://instagram.com/imigo.app" target="_blank" rel="noopener noreferrer" className="mr-[15px]">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://twitter.com/imigoapp" target="_blank" rel="noopener noreferrer" className="mr-[15px]">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="https://linkedin.com/company/imigo" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </Col>
          <Col lg={2} md={6} className="mb-[30px]">
            <h6 className="font-bold mb-[20px] text-white">{t('footer.explore')}</h6>
            <ul className="pl-0 list-none">
              {quickLinks.map((link) => (
                <li key={link.to} className="mb-[10px]">
                  <Link to={getLocalizedPath(link.to)} className="text-white hover:text-neonorange transition-all duration-300">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </Col>
          <Col lg={2} md={6} className="mb-[30px]">
            <h6 className="font-bold mb-[20px] text-white">{t('footer.resources')}</h6>
            <ul className="pl-0 list-none">
              {resourceLinks.map((link) => (
                <li key={link.to} className="mb-[10px]">
                  <Link to={getLocalizedPath(link.to)} className="text-white hover:text-neonorange transition-all duration-300">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </Col>
          <Col lg={3} md={6} className="mb-[30px]">
            <h6 className="font-bold mb-[20px] text-white">{t('footer.downloadApp')}</h6>
            <p className="mb-[20px]">{t('footer.downloadAppDesc')}</p>
            <div className="app-buttons">
              <a href="https://apps.apple.com/us/app/imigo-connect/id6744267446" target="_blank" rel="noopener noreferrer" className="btn btn-outline-light mb-[10px] mr-[10px]">
                <i className="fab fa-apple mr-[5px]"></i> {t('common.iosApp')}
              </a>
              <a href="https://play.google.com/store/apps/details?id=app.imigo" target="_blank" rel="noopener noreferrer" className="btn btn-outline-light mb-[10px]">
                <i className="fab fa-google-play mr-[5px]"></i> {t('common.androidApp')}
              </a>
            </div>
          </Col>
        </Row>
        <div className="border-t border-[#444] mt-[30px] pt-[30px] text-center">
          <p className="mb-0">&copy; {new Date().getFullYear()} Imigo. {t('footer.rights')}</p>
        </div>
      </Container>
    </footer>
  )
}

export default FooterImigo
